import React from 'react';
import styles from './CadInformation.module.scss';
import {
  CadAddressValueType,
  CadPersonValueType,
  CadPremiseValueType,
  CadSubjectValueType,
  CadValueType
} from '../../../../../Models/CadReportValue';
import { FieldItem } from '../../CommonBody/FieldItem/FieldItem';
import { FieldValueType } from '../../../../../Models';
import { getCADPersonnelFullName } from '../../CommonBody/Helpers';
import { CadDatetimeInformation } from './CadDatetimeInformation/CadDatetimeInformation';
import { CadLocationInformation } from './CadLocationInformation/CadLocationInformation';
import { CadUnitsInformation } from './CadUnitsInformation/CadUnitsInformation';
import { CadNarrativesInformation } from './CadNarrativesInformation/CadNarrativesInformation';

const getCADCallerName = (caller: CadSubjectValueType): string => {
  const name = [caller.first_name, caller.middle_name].join(' ');

  return `${caller.last_name ? [caller.last_name, name].join(', ') : name}`;
};

export interface CadInformationProps {
  cad: CadValueType;
  addresses: CadAddressValueType[];
  premises: CadPremiseValueType[];
  personnel: CadPersonValueType[];
}

export const CadInformation = ({
  cad,
  addresses,
  premises,
  personnel
}: CadInformationProps): React.ReactElement<CadInformationProps> => {
  return (
    <div className={styles.cadInformation}>
      <h3 className={styles.title}>CAD Information</h3>
      <div className={styles.items}>
        <FieldItem
          label={'Case Number'}
          value={cad['case_number'] as FieldValueType}
          type="string"
        />
        <FieldItem
          label={'Call ID'}
          value={cad['id'] as FieldValueType}
          type="string"
        />
        <FieldItem
          label={'Agency'}
          value={cad['agency'] as FieldValueType}
          type="string"
        />
        <FieldItem
          label={'Source'}
          value={cad['source'] as FieldValueType}
          type="string"
        />
        {cad.created_by_user_badge_id && (
          <FieldItem
            label={'Dispatcher'}
            value={
              getCADPersonnelFullName(
                cad['created_by_user_badge_id'],
                personnel
              ) as FieldValueType
            }
            type="string"
          />
        )}
        {cad.caller && (
          <FieldItem
            label={'Caller'}
            value={getCADCallerName(cad.caller) as FieldValueType}
            type="string"
          />
        )}
        <FieldItem
          label={'Type'}
          value={cad['type'] as FieldValueType}
          type="string"
        />
        <FieldItem
          label={'Priority'}
          value={cad['priority'] as FieldValueType}
          type="number"
        />
        <CadDatetimeInformation datetime={cad['date_time']} />
        {cad.location && (
          <CadLocationInformation
            location={cad['location']}
            premises={premises}
            Addresses={addresses}
          />
        )}
        {cad.units && personnel && (
          <CadUnitsInformation units={cad['units']} personnel={personnel} />
        )}
        {cad.primary_officer_badge_id && (
          <FieldItem
            label={'Primary Officer'}
            value={
              getCADPersonnelFullName(
                cad['primary_officer_badge_id'],
                personnel
              ) as FieldValueType
            }
            type="string"
          />
        )}
        {cad.narratives && personnel && (
          <CadNarrativesInformation
            narratives={cad['narratives']}
            personnel={personnel}
          />
        )}
        <FieldItem
          label={'Disposition'}
          value={cad['disposition'] as FieldValueType}
          type="string"
        />
        {/* NOTE: Do we need to map the 'C' value to 'Cleared' */}
        <FieldItem
          label={'Status'}
          value={
            cad['status'] === 'C'
              ? 'Cleared'
              : (cad['status'] as FieldValueType)
          }
          type="string"
        />
      </div>
    </div>
  );
};
